import { Component, effect, inject, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SiteConfigService } from '../../core/site-config.service';
import { TurkeyLocationOption, TurkeyLocationService } from '../../shared/turkey-location.service';
import { DynamicFormField, DynamicFormFieldsComponent } from '../forms/dynamic-form-fields.component';
import {
  ServiceIntakeFlow,
  ServiceIntakeStep,
  ServiceMarketplaceService,
  ServiceRequestChoice,
  ServiceRequestMatch,
  ServiceRequestMode
} from './service-marketplace.service';

@Component({
  selector: 'app-service-request-widget',
  standalone: true,
  imports: [FormsModule, DynamicFormFieldsComponent],
  template: `
    <section class="request-box">
      <header>
        <p>ÜCRETSİZ TALEP OLUŞTUR</p>
        <h2>{{ title() }} için ihtiyacını anlat.</h2>
        <span>Bilgilerini paylaş; uygun hizmet verenleri ve fiyatları tek ekranda karşılaştır.</span>
      </header>
      @if (error()) { <p class="error" role="alert">{{ error() }}</p> }

      @if (!completed()) {
        @if (instantAvailable() || quoteAvailable()) {
          <div class="mode-tabs" [class.single]="!instantAvailable() || !quoteAvailable()">
            @if (instantAvailable()) {
              <button type="button" [class.active]="mode()==='instant'" (click)="mode.set('instant')"><b>Anında fiyat</b><small>Aktif fiyatları şimdi gör</small></button>
            }
            @if (quoteAvailable()) {
              <button type="button" [class.active]="mode()==='quote'" (click)="mode.set('quote')"><b>Teklif iste</b><small>Hizmet verenler sana ulaşsın</small></button>
            }
          </div>
        }

        <form (ngSubmit)="submit()" novalidate>
          @if (flowBusy()) {
            <div class="flow-state wide"><i></i><span>Hizmete özel sorular hazırlanıyor...</span></div>
          } @else if (flow().steps.length) {
            <div class="intake wide">
              <div class="intake-head"><strong>İhtiyacını netleştirelim</strong><small>{{ flow().steps.length }} kısa adım</small></div>
              @for (step of flow().steps; track step.formID) {
                <section class="intake-step">
                  <header><span>{{ String($index + 1).padStart(2, '0') }}</span><div><h3>{{ step.title }}</h3><small>{{ step.isRequired ? 'Zorunlu adım' : 'İstersen doldurabilirsin' }}</small></div></header>
                  <app-dynamic-form-fields
                    [fields]="visibleFields(step)"
                    [model]="stepValues(step)"
                    [errors]="stepErrors(step)"
                    (uploading)="uploading.set(!!$event)"
                    (uploadError)="error.set($event.message)"
                  />
                </section>
              }
            </div>
          }

          <div class="location-head wide"><strong>Hizmet nerede verilecek?</strong><small>Konumuna hizmet veren Türkiye geneli, il geneli ve ilçe hizmet verenleri birlikte eşleştiririz.</small></div>
          <label>Ülke<select name="country" disabled><option>Türkiye</option></select></label>
          <label>İl<select [(ngModel)]="draft.cityID" name="cityID" required (ngModelChange)="cityChanged()"><option [ngValue]="null">İl seç</option>@for(city of cities();track city.id){<option [ngValue]="city.id">{{city.name}}</option>}</select></label>
          <label>İlçe<select [(ngModel)]="draft.districtID" name="districtID" required [disabled]="!draft.cityID || districtsBusy()"><option [ngValue]="null">{{districtsBusy()?'İlçeler yükleniyor...':'İlçe seç'}}</option>@for(district of districts();track district.id){<option [ngValue]="district.id">{{district.name}}</option>}</select></label>
          <label class="wide">Adres detayı (isteğe bağlı)<input [(ngModel)]="draft.location" name="location" maxlength="500" placeholder="Mahalle, sokak veya hizmet veren için kısa tarif"></label>
          <div class="contact-head wide"><strong>Sana nasıl ulaşalım?</strong><small>İletişim bilgilerin yalnızca eşleşen hizmet verenlerle paylaşılır.</small></div>
          <label>Ad soyad<input [(ngModel)]="draft.name" name="name" required autocomplete="name" maxlength="160"></label>
          <label>Telefon<input [(ngModel)]="draft.phone" name="phone" type="tel" autocomplete="tel" placeholder="05xx xxx xx xx" maxlength="60"></label>
          <label>E-posta<input [(ngModel)]="draft.email" name="email" type="email" autocomplete="email" maxlength="190"></label>
          <label class="wide">Eklemek istediklerin<textarea [(ngModel)]="draft.message" name="message" rows="5" maxlength="4000" placeholder="Tarih, saat ve özel beklentilerini kısaca yazabilirsin"></textarea></label>
          <footer class="wide">
            <small>Göndererek hizmet verenlerin talebin için iletişime geçmesini kabul edersin.</small>
            <button [disabled]="busy() || flowBusy() || uploading() || !valid() || (!instantAvailable() && !quoteAvailable())">{{ busy() ? 'Gönderiliyor...' : mode()==='instant' ? 'Fiyatları göster' : 'Teklif iste' }}</button>
          </footer>
        </form>
      } @else {
        <div class="success"><i>✓</i><div><p>Talebin oluşturuldu</p><h3>Talep numaran: #{{ requestID() }}</h3><span>{{ successMessage() || (matches().length ? matches().length+' uygun hizmet veren bulundu.' : 'Uygun hizmet verenlere bildirim gönderilecek.') }}</span></div></div>
        @if (matches().length) {
          <div class="matches">
            @for (item of matches(); track item.offerID) {
              <article><div><small>@if(item.durationMinutes){ {{ item.durationMinutes }} dakika }</small><h3>{{ item.sellerName }}</h3>@if(item.description){<p>{{ item.description }}</p>}</div><div class="match-action">@if(item.price!==null){<strong>{{ item.price }} {{ item.currency }}</strong><button type="button" [disabled]="accepting()" (click)="accept({offerID:item.offerID,sellerID:item.sellerID,sellerName:item.sellerName,amount:item.price||0,currency:item.currency,durationMinutes:item.durationMinutes})">Bu hizmet vereni seç</button>}@else{<b>Teklif bekleniyor</b>}</div></article>
            }
          </div>
        }
        @if (requestToken() && mode()==='quote') {
          <section class="quote-status">
            <header><div><strong>Hizmet veren teklifleri</strong><small>Bu ekranı kapatmadan teklifleri yenileyebilirsin.</small></div><button type="button" [disabled]="refreshing()" (click)="refreshStatus()">{{refreshing()?'Yenileniyor...':'Teklifleri yenile'}}</button></header>
            @for (quote of quotes(); track quote.quoteID) {
              <article><div><small>{{quote.durationMinutes}} dakika</small><h3>{{quote.sellerName}}</h3>@if(quote.message){<p>{{quote.message}}</p>}</div><div><strong>{{quote.amount}} {{quote.currency}}</strong><button type="button" [disabled]="accepting()" (click)="accept(quote)">Teklifi kabul et</button></div></article>
            } @empty { <p class="waiting">Teklifler ulaştığında burada görünecek.</p> }
          </section>
        }
        @if (accepted()) { <p class="accepted">✓ Hizmet veren seçimin kaydedildi. Talep numaranla süreç devam edecek.</p> }
        <button class="again" type="button" (click)="reset()">Yeni talep oluştur</button>
      }
    </section>
  `,
  styles: [`
    :host{display:block}.request-box{background:var(--ink);border-radius:34px;color:var(--paper);display:grid;gap:22px;padding:clamp(22px,5vw,48px)}.request-box>header{display:grid;gap:8px}.request-box>header p{color:var(--accent);font-size:.72rem;font-weight:950;letter-spacing:.15em;margin:0}.request-box>header h2{font-family:var(--font-display,Georgia,serif);font-size:clamp(2rem,4vw,3.8rem);letter-spacing:-.05em;margin:0}.request-box>header span,footer small{color:color-mix(in srgb,var(--paper) 65%,transparent);line-height:1.55}.mode-tabs{display:grid;gap:10px;grid-template-columns:repeat(2,1fr)}.mode-tabs.single{grid-template-columns:1fr}.mode-tabs button{background:color-mix(in srgb,var(--paper) 7%,transparent);border:1px solid color-mix(in srgb,var(--paper) 16%,transparent);border-radius:18px;color:var(--paper);cursor:pointer;display:grid;gap:3px;padding:15px;text-align:left}.mode-tabs button.active{background:color-mix(in srgb,var(--accent) 20%,transparent);border-color:var(--accent)}.mode-tabs small{color:color-mix(in srgb,var(--paper) 60%,transparent)}form{display:grid;gap:14px;grid-template-columns:repeat(3,minmax(0,1fr))}form>label{display:grid;gap:7px;font-size:.78rem;font-weight:900}.wide{grid-column:1/-1}form>label :is(input,select,textarea){background:color-mix(in srgb,var(--paper) 8%,transparent);border:1px solid color-mix(in srgb,var(--paper) 18%,transparent);border-radius:15px;box-sizing:border-box;color:var(--paper);font:inherit;padding:14px;width:100%}form>label select option{background:var(--ink);color:var(--paper)}form>label select:disabled{opacity:.65}.contact-head,.location-head{align-items:end;border-top:1px solid color-mix(in srgb,var(--paper) 15%,transparent);display:flex;gap:12px;justify-content:space-between;padding-top:20px}.location-head{border-top:0;padding-top:4px}.contact-head strong,.location-head strong{font-size:1.15rem}.contact-head small,.location-head small{color:color-mix(in srgb,var(--paper) 58%,transparent)}.intake{display:grid;gap:12px}.intake-head{align-items:center;display:flex;justify-content:space-between}.intake-head small{color:color-mix(in srgb,var(--paper) 60%,transparent)}.intake-step{background:var(--paper);border-radius:22px;color:var(--ink);display:grid;gap:18px;padding:clamp(16px,3vw,24px)}.intake-step>header{align-items:center;display:flex;gap:12px}.intake-step>header>span{align-items:center;background:color-mix(in srgb,var(--accent) 15%,transparent);border-radius:50%;color:var(--accent);display:flex;font-size:.72rem;font-weight:950;height:38px;justify-content:center;width:38px}.intake-step h3{font-size:1.1rem;margin:0}.intake-step header small{color:var(--muted)}.flow-state{align-items:center;background:color-mix(in srgb,var(--paper) 7%,transparent);border:1px solid color-mix(in srgb,var(--paper) 14%,transparent);border-radius:18px;display:flex;gap:10px;padding:16px}.flow-state i{animation:pulse 1s ease-in-out infinite;background:var(--accent);border-radius:50%;height:10px;width:10px}footer{align-items:center;display:flex;gap:20px;justify-content:space-between}footer button,.again,.matches button,.quote-status button{background:var(--accent);border:0;border-radius:999px;color:var(--accent-contrast);cursor:pointer;font:inherit;font-size:.8rem;font-weight:950;padding:11px 16px}footer button:disabled,.matches button:disabled,.quote-status button:disabled{cursor:not-allowed;opacity:.5}.error{color:#ffafbd;margin:0}.success{align-items:center;display:flex;gap:16px}.success>i{align-items:center;background:var(--accent);border-radius:50%;color:var(--accent-contrast);display:flex;font-size:1.5rem;font-style:normal;height:58px;justify-content:center;width:58px}.success p{color:var(--accent);font-weight:900;margin:0}.success h3{font-size:1.6rem;margin:4px 0}.matches{display:grid;gap:10px}.matches article,.quote-status article{align-items:center;background:color-mix(in srgb,var(--paper) 7%,transparent);border:1px solid color-mix(in srgb,var(--paper) 14%,transparent);border-radius:18px;display:flex;gap:20px;justify-content:space-between;padding:16px}.matches h3,.matches p,.quote-status h3,.quote-status p{margin:3px 0}.matches p,.matches small,.quote-status small{color:color-mix(in srgb,var(--paper) 62%,transparent)}.matches strong,.quote-status strong{color:var(--accent);font-size:1.25rem;white-space:nowrap}.match-action,.quote-status article>div:last-child{align-items:flex-end;display:grid;gap:8px;justify-items:end}.quote-status{display:grid;gap:10px}.quote-status>header{align-items:center;display:flex;gap:18px;justify-content:space-between}.quote-status>header>div{display:grid;gap:3px}.quote-status>header strong{color:var(--paper);font-size:1rem}.waiting{border:1px dashed color-mix(in srgb,var(--paper) 20%,transparent);border-radius:16px;color:color-mix(in srgb,var(--paper) 65%,transparent);padding:16px}.accepted{background:color-mix(in srgb,var(--accent) 18%,transparent);border:1px solid var(--accent);border-radius:16px;color:var(--accent);font-weight:900;padding:14px}.again{justify-self:start}@keyframes pulse{50%{opacity:.3}}@media(max-width:720px){form{grid-template-columns:1fr}.wide{grid-column:auto}footer,.contact-head,.location-head,.quote-status>header{align-items:stretch;display:grid}.mode-tabs{grid-template-columns:1fr}.matches article,.quote-status article{align-items:start;display:grid}.match-action,.quote-status article>div:last-child{justify-items:start}}
  `]
})
export class ServiceRequestWidgetComponent {
  private readonly marketplace = inject(ServiceMarketplaceService);
  private readonly locations = inject(TurkeyLocationService);
  protected readonly site = inject(SiteConfigService);
  readonly listingID = input(0);
  readonly title = input('Hizmet');
  readonly instantAvailable = input(true);
  readonly quoteAvailable = input(true);
  protected readonly mode = signal<ServiceRequestMode>('instant');
  protected readonly flow = signal<ServiceIntakeFlow>({ listingID: 0, flowID: null, flowType: 'none', stepProcessReminderID: null, steps: [] });
  protected readonly flowBusy = signal(true);
  protected readonly uploading = signal(false);
  protected readonly busy = signal(false);
  protected readonly error = signal('');
  protected readonly completed = signal(false);
  protected readonly requestID = signal(0);
  protected readonly successMessage = signal('');
  protected readonly matches = signal<ServiceRequestMatch[]>([]);
  protected readonly requestToken = signal('');
  protected readonly quotes = signal<ServiceRequestChoice[]>([]);
  protected readonly refreshing = signal(false);
  protected readonly accepting = signal(false);
  protected readonly accepted = signal(false);
  protected readonly cities = signal<TurkeyLocationOption[]>([]);
  protected readonly districts = signal<TurkeyLocationOption[]>([]);
  protected readonly districtsBusy = signal(false);
  protected readonly String = String;
  protected draft = { name: '', phone: '', email: '', cityID: null as number | null, districtID: null as number | null, location: '', message: '' };
  private readonly values: Record<number, Record<string, unknown>> = {};
  private readonly errors: Record<number, Record<string, string>> = {};
  private loadedListingID = 0;

  constructor() {
    void this.loadCities();
    effect(() => {
      const listingID = this.listingID();
      if (this.instantAvailable()) this.mode.set('instant');
      else if (this.quoteAvailable()) this.mode.set('quote');
      if (listingID > 0 && listingID !== this.loadedListingID) {
        this.loadedListingID = listingID;
        void this.loadFlow(listingID);
      }
    });
  }

  protected valid(): boolean {
    return this.draft.name.trim() !== '' && (this.draft.phone.trim() !== '' || this.draft.email.trim() !== '') && !!this.draft.cityID && !!this.draft.districtID;
  }

  protected async cityChanged(): Promise<void> {
    this.draft.districtID = null;
    this.districts.set([]);
    if (!this.draft.cityID) return;
    try {
      this.districtsBusy.set(true);
      this.districts.set(await this.locations.districts(this.draft.cityID));
    } catch {
      this.error.set('İlçeler yüklenemedi. Lütfen tekrar dene.');
    } finally {
      this.districtsBusy.set(false);
    }
  }

  private async loadCities(): Promise<void> {
    try { this.cities.set(await this.locations.cities()); }
    catch { this.error.set('İller yüklenemedi. Lütfen sayfayı yenile.'); }
  }

  protected stepValues(step: ServiceIntakeStep): Record<string, unknown> {
    return this.values[step.formID] ??= {};
  }

  protected stepErrors(step: ServiceIntakeStep): Record<string, string> {
    return this.errors[step.formID] ??= {};
  }

  protected visibleFields(step: ServiceIntakeStep): DynamicFormField[] {
    const values = this.stepValues(step);
    return step.fields.filter((field) => Number((field as DynamicFormField & { showDisplay?: boolean | number }).showDisplay ?? 1) !== 0 && !this.locationField(field) && this.conditionMatches(field, values));
  }

  protected async submit(): Promise<void> {
    if (!this.valid() || this.busy() || this.uploading()) return;
    this.applyStructuredLocation();
    if (!this.validateIntake()) return;
    try {
      this.busy.set(true);
      this.error.set('');
      const cityName=this.cities().find(item=>item.id===this.draft.cityID)?.name||'';
      const districtName=this.districts().find(item=>item.id===this.draft.districtID)?.name||'';
      const result = await this.marketplace.createRequest({
        listingID: this.listingID(),
        requestMode: this.mode(),
        ...this.draft,
        location:[districtName,cityName,'Türkiye',this.draft.location.trim()].filter(Boolean).join(', '),
        countryCode: 'TR',
        expiryHours: this.site.config().business?.quoteExpiryHours || 48,
        intakeAnswers: this.flow().steps.map((step) => ({
          formID: step.formID,
          stepProcessReminderFormID: step.id,
          values: this.stepValues(step)
        }))
      });
      if (!result.requestID) throw new Error('Talep numarası alınamadı.');
      this.requestID.set(result.requestID);
      this.requestToken.set(result.requestToken);
      this.matches.set(result.matches);
      this.successMessage.set(result.message);
      this.completed.set(true);
    } catch (error) {
      this.error.set(this.marketplace.errorMessage(error, 'Talebin oluşturulamadı.'));
    } finally {
      this.busy.set(false);
    }
  }

  protected reset(): void {
    this.completed.set(false);
    this.requestID.set(0);
    this.matches.set([]);
    this.requestToken.set('');
    this.quotes.set([]);
    this.accepted.set(false);
    this.successMessage.set('');
    this.error.set('');
    for (const key of Object.keys(this.values)) this.values[Number(key)] = {};
    for (const key of Object.keys(this.errors)) this.errors[Number(key)] = {};
  }

  protected async refreshStatus(): Promise<void> {
    if (!this.requestID() || !this.requestToken() || this.refreshing()) return;
    try {
      this.refreshing.set(true);
      this.error.set('');
      const status = await this.marketplace.requestStatus(this.requestID(), this.requestToken());
      this.quotes.set(status.quotes);
      this.accepted.set(status.status === 'accepted' || status.status === 'ordered');
    } catch (error) {
      this.error.set(this.marketplace.errorMessage(error, 'Teklifler yenilenemedi.'));
    } finally {
      this.refreshing.set(false);
    }
  }

  protected async accept(choice: ServiceRequestChoice): Promise<void> {
    if (this.accepting() || this.accepted()) return;
    try {
      this.accepting.set(true);
      this.error.set('');
      await this.marketplace.acceptSelection(this.requestID(), this.requestToken(), choice.quoteID ? { quoteID: choice.quoteID } : { offerID: choice.offerID });
      this.accepted.set(true);
    } catch (error) {
      this.error.set(this.marketplace.errorMessage(error, 'Hizmet veren seçilemedi.'));
    } finally {
      this.accepting.set(false);
    }
  }

  private async loadFlow(listingID: number): Promise<void> {
    try {
      this.flowBusy.set(true);
      this.error.set('');
      this.flow.set(await this.marketplace.intakeFlow(listingID));
    } catch (error) {
      this.error.set(this.marketplace.errorMessage(error, 'Hizmete özel sorular alınamadı.'));
    } finally {
      this.flowBusy.set(false);
    }
  }

  private validateIntake(): boolean {
    let valid = true;
    for (const step of this.flow().steps) {
      const values = this.stepValues(step);
      const stepErrors: Record<string, string> = {};
      const hasAny = Object.values(values).some((value) => this.hasValue(value));
      if (!step.isRequired && !hasAny) {
        this.errors[step.formID] = {};
        continue;
      }
      for (const field of this.visibleFields(step)) {
        const key = String(field.formKey || `field_${field.id || 'x'}`);
        const value = values[key];
        const empty = !this.hasValue(value);
        const length = Array.isArray(value) ? value.length : String(value ?? '').trim().length;
        const min = Number(field.minlenght ?? field.minlength ?? 0);
        const max = Number(field.maxlenght ?? field.maxlength ?? 0);
        const required = field.required === true || Number(field.required || 0) === 1;
        if (required && empty) stepErrors[key] = 'required';
        else if (!empty && min > 0 && length < min) stepErrors[key] = 'minlength';
        else if (!empty && max > 0 && length > max) stepErrors[key] = 'maxlength';
      }
      this.errors[step.formID] = stepErrors;
      if (Object.keys(stepErrors).length) valid = false;
    }
    if (!valid) this.error.set('Lütfen hizmet bilgi alanlarını kontrol et.');
    return valid;
  }

  private applyStructuredLocation(): void {
    const city=this.cities().find(item=>item.id===this.draft.cityID)?.name||'';
    const district=this.districts().find(item=>item.id===this.draft.districtID)?.name||'';
    const value=[district,city,'Türkiye',this.draft.location.trim()].filter(Boolean).join(', ');
    for(const step of this.flow().steps){
      const values=this.stepValues(step);
      for(const field of step.fields){if(this.locationField(field))values[String(field.formKey||`field_${field.id||'x'}`)]=value;}
    }
  }

  private locationField(field:DynamicFormField):boolean{
    const key=String(field.formKey||'').toLocaleLowerCase('tr-TR').replace(/[^a-z0-9çğıöşü]/g,'');
    const title=String(field.title||'').toLocaleLowerCase('tr-TR');
    return ['address','adres','serviceaddress','hizmetadresi','location','konum'].includes(key)||title.includes('hizmet adres')||title.includes('hizmet konum');
  }

  private hasValue(value: unknown): boolean {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object') return Object.values(value as Record<string, unknown>).some(Boolean);
    return true;
  }

  private conditionMatches(field: DynamicFormField, values: Record<string, unknown>): boolean {
    const conditional = field as DynamicFormField & { conditionFieldKey?: string; conditionOperator?: string; conditionValue?: string };
    const key = String(conditional.conditionFieldKey || '').trim();
    if (!key) return true;
    const actual = values[key];
    const expected = String(conditional.conditionValue ?? '');
    const list = Array.isArray(actual) ? actual.map(String) : typeof actual === 'object' && actual ? Object.entries(actual as Record<string, unknown>).filter(([, enabled]) => !!enabled).map(([value]) => value) : [String(actual ?? '')];
    switch (String(conditional.conditionOperator || 'equals')) {
      case 'not_equals': return !list.includes(expected);
      case 'in': return list.some((value) => expected.split(',').map((item) => item.trim()).includes(value));
      case 'not_in': return !list.some((value) => expected.split(',').map((item) => item.trim()).includes(value));
      case 'filled': return list.some((value) => value !== '');
      case 'empty': return list.every((value) => value === '');
      default: return list.includes(expected);
    }
  }
}
